import React, { Component } from 'react';
import SideMenu             from './sidemenu/sidemenu';
import CateReports          from './cate-reports/cate-reports';


class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rpt_des: [],
            slug   : '',
            sub:'',
            Isrender : true,
            error: null,
            isLoaded:false
        };
        this.state.slug = this.props.slug;
        this.state.sub = this.props.sub;
    }

    render() {
        return (
            <div>
                <SideMenu />
                <CateReports slug={this.state.slug} sub={this.state.sub} location={this.props.location} />
            </div>
        );
    }

}


export default Content;


// WEBPACK FOOTER //
// ./src/industry-reports/content/content.js